import { Command, usePrintActionHandler } from '@nest/internal-frontend';
import { PrinterIcon } from 'lucide-react';
import { useTerminalClient } from '../client-rpc-router';
import { useNumberParam } from '../helpers';

export const useCommandPrintConsignmentNote = (): Command => {
	const client = useTerminalClient();
	const consignmentNoteId = useNumberParam('consignmentNoteId');
	const printActionHandler = usePrintActionHandler(
		'consignment-note',
		async (numberOfCopies, printerIds) => {
			const result = await client.consignmentNotes.printConsignmentNoteQuery.execute({
				consignmentNoteId: consignmentNoteId!,
				numberOfCopies,
				printerIds
			});

			if (result == null) {
				return;
			}

			return result;
		},
		{
			allowedActions: ['print']
		}
	);

	return {
		id: 'print-consignment-note',
		label: 'Tisk',
		icon: <PrinterIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: undefined,
		loading: undefined,
		run: async () => {
			printActionHandler.run();
		}
	};
};
